import React from 'react'
import {Box,Text, Stack, Button, Input } from '@chakra-ui/react'

const Newsletter = () => {
  return (
    <Box w='full' bg='#1F1F29' h='100vh' gap='6' display={['none','flex']} flexWrap='wrap' justifyContent='center' alignItems='center' p={['2rem','4rem']}>
        <Box w={['95%','80%']} h='70%' bg='#246BFD' flexDirection='column' borderRadius='24px' display='flex' justifyContent='space-between' alignItems='center' p={['2rem','4rem']} >
        <Text fontSize={['1.35rem','1.75rem','1.8rem','3rem']} color='#fff'  textAlign='center' fontFamily='Duplicate Sans' fontWeight='500'>
        Suscribe to our Newsletter
        </Text>
        <Text fontFamily='Work Sans' fontSize={['.75rem','.75rem','.75rem','1rem']} lineHeight={['1rem','1rem','1rem','28px']}   textAlign='center' color='#fff'>
        More than creating a seamless platform for you to access your funds, <br/>
we are bringing to you cardless transactions.</Text>
            <Stack direction={['column','row']} display='flex' alignItems='center' w={['100%','75%']}>
                <Input p={['.8rem','1rem','1rem','1.5rem']} fontSize={['.75rem','.75rem','.75rem','1rem']} fontWeight='500' placeholder='Enter your email address' color='#CACCCF' bg='#fff' borderRadius='8px' w='100%' />
                <Button fontFamily='Work Sans' p={['.95rem','1rem','1rem','1.5rem']} fontSize={['.7rem','.7rem','.7rem','1rem']} color='#fff' bg='#1F1F29' borderRadius='8px'  >Suscribe</Button>
            </Stack>
        </Box>
    </Box>
  )
}

export default Newsletter